import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ScriptLoaderService, ClassService, DashboardService } from '../../../../_services';
import { DatePickerComponent } from './../../../../shared/date-picker';
import { LiveSearchSelectComponent } from './../../../../shared/live-search-select';

@Component({
    selector: "app-index",
    templateUrl: "./index.component.html",
    providers: [DashboardService]
})
export class IndexComponent implements OnInit, AfterViewInit {

    data: any;
    barChartYears: any;
    year: number;
    public barChartData: any[];
    @ViewChild('startDate') startDate: DatePickerComponent;
    @ViewChild('endDate') endDate: DatePickerComponent;
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    constructor(
        private _script: ScriptLoaderService,
        private _classService: ClassService,
        private _dashboardService: DashboardService) {

    }

    fromTexts = {
        label: "Desde",
        placeholder: ""
    };
    toTexts = {
        label: "Hasta",
        placeholder: ""
    };
    ngOnInit() {
        this.getBarChart();
        this.initialYear();

    }
    ngAfterViewInit() {
        this._classService.setClass(document.body, IndexComponent.initialClass);
        this.startDate.getFirstDayMonth();
        this.endDate.getNow();
        this.search();

    }

    buildSearchString() {
        let result = ``;
        if (!this.startDate.empty()) {
            result += `&start_date=${this.startDate.value.string}`;
        }
        if (!this.endDate.empty()) {
            result += `&end_date=${this.endDate.value.string}`;
        }
        if (this.year) {
            result += `&year=${this.year}`;
        }
        return result;
    }
    clear() {
        this.startDate.clear();
        this.endDate.clear();
    }

    search() {
        this._dashboardService.getAll(this.buildSearchString()).subscribe(data => {
            this.data = data;
        });
    }
    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };

    public barChartLabels: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    public barChartType: string = 'bar';
    public barChartLegend: boolean = true;
    public barChartColors: any[] = [
        {
            backgroundColor: 'rgba(52,191,163,1)',

        },
        {
            backgroundColor: 'rgba(244,81,108,1)',
        }
    ];

    // events They can be used
    public chartClicked(e: any): void {
        //console.log(e);
    }

    public chartHovered(e: any): void {
        //console.log(e);
    }

    public getBarChart() {
        this._dashboardService.getBarChart(this.buildSearchString()).subscribe(data => {
            this.barChartYears = data.years;
            let incomes = [];
            let expenses = [];
            for (let income in data.incomes) {
                incomes.push(data.incomes[income]);
            }
            for (let expense in data.expenses) {
                expenses.push(data.expenses[expense]);
            }
            this.barChartData = [
                { data: incomes, label: 'Ingresos' },
                { data: expenses, label: 'Egresos' }
            ];
        });
    }
    public changeBarChart() {
        this.getBarChart();
    }

    public initialYear() {
        this._dashboardService.getBarChart().subscribe(data => {
            this.year = data.years[0];
        });
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/index/index.component.ts